'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Recharge = exports.VAL_SUBSCRIPTION = exports.ATTR_UNIT_TYPE = exports.FREQUENCY_SELECTOR = exports.PURCHASE_OPTION_SELECTOR = exports.RECHARGE_OPTIONS_CONTAINER = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
var RECHARGE_OPTIONS_CONTAINER = exports.RECHARGE_OPTIONS_CONTAINER = '[data-product-subscription]'; /*
                                                                                                      *  Recharge
                                                                                                      *    Tool for integrating standard add to cart functionality
                                                                                                      *    with reCharge's variant data. Please ensure your variant
                                                                                                      *    selector has been modified to support the subscription IDs
                                                                                                      *    coming from reCharge's metafields.
                                                                                                      *
                                                                                                      *
                                                                                                      *  Version:
                                                                                                      *    1.0.0 - 2020/07/28
                                                                                                      */

var PURCHASE_OPTION_SELECTOR = exports.PURCHASE_OPTION_SELECTOR = '[data-purchase-option]';
var FREQUENCY_SELECTOR = exports.FREQUENCY_SELECTOR = '[data-frequency-select]';

//Attrs
var ATTR_UNIT_TYPE = exports.ATTR_UNIT_TYPE = 'data-frequency-unit-type';
var VAL_SUBSCRIPTION = exports.VAL_SUBSCRIPTION = 'subscription';

var Recharge = exports.Recharge = function () {
  function Recharge(container) {
    (0, _classCallCheck3.default)(this, Recharge);

    this.container = container;

    this.init();
  }

  (0, _createClass3.default)(Recharge, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.radioOptions = this.container.find(PURCHASE_OPTION_SELECTOR);
      this.frequencySelector = this.container.find(FREQUENCY_SELECTOR);

      if (!this.radioOptions.length || !this.frequencySelector.length) return;

      this.findSelectedOption();
      this.container.on('click touchend', PURCHASE_OPTION_SELECTOR, function (e) {
        return _this.onOptionSelect(e);
      });
    }
  }, {
    key: 'findSelectedOption',
    value: function findSelectedOption() {
      var _this2 = this;

      this.radioOptions.each(function (i, e) {
        if ((0, _jquery2.default)(e).is(':checked')) _this2.purchaseOption = (0, _jquery2.default)(e).val();
      });
    }
  }, {
    key: 'onOptionSelect',
    value: function onOptionSelect(e) {
      this.purchaseOption = (0, _jquery2.default)(e.currentTarget).val();
    }
  }, {
    key: 'isRechargeSelected',
    value: function isRechargeSelected() {
      return this.purchaseOption == VAL_SUBSCRIPTION;
    }
  }, {
    key: 'getSelectedFrequency',
    value: function getSelectedFrequency() {
      return this.frequencySelector.find('option:selected').val();
    }
  }, {
    key: 'getFrequencyUnit',
    value: function getFrequencyUnit() {
      return this.frequencySelector.attr(ATTR_UNIT_TYPE);;
    }
  }]);
  return Recharge;
}();